import React from "react";

const InfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.399"
    height="11.399"
    viewBox="0 0 11.399 11.399"
    {...props}
  >
    <g
      id="Group_6302"
      data-name="Group 6302"
      transform="translate(-401.574 -330.963)"
    >
      <circle
        id="Ellipse_8"
        data-name="Ellipse 8"
        cx="5.074"
        cy="5.074"
        r="5.074"
        transform="translate(402.199 331.588)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <line
        id="Line_466"
        data-name="Line 466"
        y1="2.562"
        transform="translate(407.273 336.502)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <line
        id="Line_467"
        data-name="Line 467"
        transform="translate(407.273 334.438)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </g>
  </svg>
);

export default InfoIcon;



// WEBPACK FOOTER //
// ./src/components/icons/InfoIcon.jsx